'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dom = require('../utils/Dom');

var _underscore = require('../utils/underscore');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Selectors = require('../constants/Selectors');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

var _ReactNodes = require('../core/ReactNodes');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _decorators = require('../utils/propTypes/decorators');

var _UIAbstractDropdown = require('./abstract/UIAbstractDropdown');

var _UIAbstractDropdown2 = _interopRequireDefault(_UIAbstractDropdown);

var _UIAbstractDropdownWithSearchbox = require('./abstract/UIAbstractDropdownWithSearchbox');

var _UIAbstractDropdownWithSearchbox2 = _interopRequireDefault(_UIAbstractDropdownWithSearchbox);

var _UIPopover = require('../tooltip/UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _PlacementConstants = require('../tooltip/PlacementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var USE_CLASSES = {
  list: 'private-dropdown--list',
  unstyled: ''
};

var UIDropdown = function (_PureComponent) {
  _inherits(UIDropdown, _PureComponent);

  function UIDropdown(props) {
    _classCallCheck(this, UIDropdown);

    var _this = _possibleConstructorReturn(this, (UIDropdown.__proto__ || Object.getPrototypeOf(UIDropdown)).call(this, props));

    _this.state = {
      hasSearchbox: false
    };
    _this._id = 'dropdown-menu-' + (0, _underscore.uniqueId)();
    _this.menuRefCallback = _this.menuRefCallback.bind(_this);
    _this.handleMenuClick = _this.handleMenuClick.bind(_this);
    _this.handleOpenComplete = _this.handleOpenComplete.bind(_this);
    _this.handleSearchChange = _this.handleSearchChange.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(UIDropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Only autofocus when `open` prop goes from false => true
      if (!this.props.open && nextProps.open) {
        this._enableAutofocus = true;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkForSearchbox();

      // Reposition the Tether, as the results list may have changed height.
      if (this._dropdownRef) {
        this._dropdownRef.reposition();
      }
    }
  }, {
    key: 'checkForSearchbox',
    value: function checkForSearchbox() {
      // Check if we have a searchbox, as we may need to make the arrow color match.
      if (this._menuEl && document.body.contains(this._menuEl)) {
        var hasSearchbox = !!this._menuEl.querySelector('.private-typeahead:not(.hide-search)');
        if (this.state.hasSearchbox !== hasSearchbox) {
          this.setState({ hasSearchbox: hasSearchbox });
        }
      }
    }
  }, {
    key: 'menuRefCallback',
    value: function menuRefCallback(ref) {
      this._menuEl = ref;
      if (ref) this.checkForSearchbox();
    }
  }, {
    key: 'handleMenuClick',
    value: function handleMenuClick(evt) {
      var _props = this.props,
          closeOnMenuClick = _props.closeOnMenuClick,
          onOpenChange = _props.onOpenChange;

      if (closeOnMenuClick) {
        var target = evt.target;


        var iterableTarget = target;

        var menu = document.getElementById(this._id);
        if (!menu || !menu.contains(target)) return; // Portals! #6595

        while (iterableTarget && !(0, _Dom.elementHasClass)(iterableTarget, 'private-dropdown') && iterableTarget.getAttribute('data-component-name') !== 'UIFileButton') {
          // Only close when clicking a `button` or `a` tag!
          if (['BUTTON', 'A'].includes(iterableTarget.nodeName) && !iterableTarget.disabled) {
            onOpenChange((0, _SyntheticEvent2.default)(false));
            return;
          }

          iterableTarget = iterableTarget.parentElement;
        }
      }
    }
  }, {
    key: 'handleOpenComplete',
    value: function handleOpenComplete() {
      var onOpenComplete = this.props.onOpenComplete;

      (0, _Functions.callIfPossible)(onOpenComplete);

      if (this._typeaheadRef && this._enableAutofocus) {
        (0, _Functions.callIfPossible)(this._typeaheadRef.focus);
        this._enableAutofocus = false;
      }
    }
  }, {
    key: 'handleSearchChange',
    value: function handleSearchChange() {
      this.forceUpdate(); // Reposition the Tether after the search results flush to the DOM
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      var key = evt.key;
      var _props2 = this.props,
          onOpenChange = _props2.onOpenChange,
          open = _props2.open,
          use = _props2.use;

      if (!open) return;

      if (this.state.hasSearchbox) {
        if (key === 'Enter') {
          onOpenChange((0, _SyntheticEvent2.default)(false));
        }
        evt.stopPropagation();
        return;
      }

      // Move the focus to the next/prev menu item (<li>).
      if (use !== 'unstyled' && (key === 'ArrowDown' || key === 'ArrowUp')) {
        var menu = document.getElementById(this._id);
        if (!menu) return;
        var allMenuItems = menu.querySelectorAll('li');
        if (allMenuItems.length === 0) return;
        var currentMenuItem = (0, _Dom.closest)(document.activeElement, 'li');

        var nextMenuItem = key === 'ArrowDown' ? currentMenuItem && currentMenuItem.nextSibling || allMenuItems[0] : currentMenuItem && currentMenuItem.previousSibling || (0, _underscore.last)(allMenuItems);

        while (nextMenuItem !== currentMenuItem) {
          var focusTarget = nextMenuItem.querySelector(_Selectors.FOCUSABLE);
          if (focusTarget) {
            evt.preventDefault();
            focusTarget.focus();
            break;
          }
          nextMenuItem = key === 'ArrowDown' ? nextMenuItem.nextSibling || allMenuItems[0] : nextMenuItem.previousSibling || (0, _underscore.last)(allMenuItems);
        }

        evt.stopPropagation();
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this2 = this;

      var _props3 = this.props,
          children = _props3.children,
          Content = _props3.Content;
      var hasSearchbox = this.state.hasSearchbox;

      var mutatedChildren = children;
      if (hasSearchbox && !Content) {
        mutatedChildren = _react.Children.map(children, function (child) {
          if ((0, _ReactNodes.nodeDisplayNameMatches)(child, /UITypeahead|UIGroupedTypeahead/)) {
            return _react2.default.cloneElement(child, {
              onSearchChange: (0, _Functions.memoizedSequence)(child.props.onSearchChange, _this2.handleSearchChange),
              ref: function ref(typeaheadRef) {
                _this2._typeaheadRef = typeaheadRef;
              }
            });
          }
          return child;
        });
      }

      return _react2.default.createElement(
        'div',
        {
          id: this._id,
          onClick: this.handleMenuClick,
          ref: this.menuRefCallback,
          role: 'presentation'
        },
        Content ? _react2.default.createElement(Content, null) : mutatedChildren
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          autoPlacement = _props4.autoPlacement,
          buttonClassName = _props4.buttonClassName,
          buttonText = _props4.buttonText,
          buttonUse = _props4.buttonUse,
          children = _props4.children,
          className = _props4.className,
          __closeOnMenuClick = _props4.closeOnMenuClick,
          __Content = _props4.Content,
          dropdownClassName = _props4.dropdownClassName,
          locked = _props4.locked,
          iconName = _props4.iconName,
          popoverProps = _props4.popoverProps,
          use = _props4.use,
          rest = _objectWithoutProperties(_props4, ['autoPlacement', 'buttonClassName', 'buttonText', 'buttonUse', 'children', 'className', 'closeOnMenuClick', 'Content', 'dropdownClassName', 'locked', 'iconName', 'popoverProps', 'use']);

      var containsFooter = _react.Children.toArray(children).some(function (child) {
        return (0, _ReactNodes.nodeDisplayNameMatches)(child, /UIDropdownFooter/);
      });

      var computedDropdownClassName = (0, _classNames2.default)(className, dropdownClassName, USE_CLASSES[use], {
        'p-y-0': containsFooter
      });

      var defaultIcon = buttonText ? undefined : 'settings';

      return _react2.default.createElement(_UIAbstractDropdownWithSearchbox2.default, _extends({}, rest, {
        autoPlacement: autoPlacement,
        buttonText: buttonText,
        buttonUse: buttonUse,
        className: buttonClassName,
        Content: this.renderContent,
        dropdownClassName: computedDropdownClassName,
        hasSearchbox: this.state.hasSearchbox,
        iconName: iconName !== undefined ? iconName : defaultIcon,
        locked: locked,
        onOpenComplete: this.handleOpenComplete,
        onKeyDown: this.handleKeyDown,
        popoverProps: popoverProps,
        ref: function ref(_ref) {
          _this3._dropdownRef = _ref;
        }
      }));
    }
  }]);

  return UIDropdown;
}(_react.PureComponent);

UIDropdown.propTypes = _extends({}, _UIAbstractDropdown2.default.propTypes, {
  arrowColor: (0, _decorators.hidden)(_UIAbstractDropdown2.default.propTypes.arrowColor),
  buttonClassName: _react.PropTypes.string,
  buttonText: _UIAbstractDropdown2.default.propTypes.buttonText,
  children: _UIAbstractDropdown2.default.propTypes.children,
  closeOnMenuClick: _react.PropTypes.bool.isRequired,
  iconName: _UIAbstractDropdown2.default.propTypes.iconName,
  locked: _UIAbstractDropdown2.default.propTypes.locked,
  onOpenChange: _UIAbstractDropdown2.default.propTypes.onOpenChange,
  open: _UIAbstractDropdown2.default.propTypes.open,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
  popoverProps: (0, _passthroughProps2.default)(_UIPopover2.default),
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
});

UIDropdown.defaultProps = _extends({}, _UIAbstractDropdown2.default.defaultProps, {
  buttonUse: 'tertiary-light',
  closeOnMenuClick: true,
  menuWidth: 'auto',
  pinToConstraint: true,
  use: 'list'
});

UIDropdown.displayName = 'UIDropdown';

exports.default = (0, _Controllable2.default)(UIDropdown, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/dropdown/UIDropdown.js
// module id = 526
// module chunks = 171